import { useEffect, useState } from "react";
import { fetchData } from "../common/services/ApiClient";
import { Form, FormSelectChoice, KeyValue } from "../interfaces";
import { ApiBaseUrl } from "../config";
import { selectedStatesAlpha } from "../refdata/FilterOptions";

export default function useGetStateList(
  form: Form,
  setForm: (form: any) => void,
) {
  const [stateList, setStateList] = useState<FormSelectChoice[]>([]);
  const [prevAppState, setPrevAppState] = useState<KeyValue>();

  useEffect(() => {
    let isMounted = true;
    if (JSON.stringify(form) !== JSON.stringify(prevAppState)) {
      const cert = form.cert
        ? form.lastYear
          ? ` AND CERT:${form.cert}`
          : `CERT:${form.cert}`
        : "";
      const name = form.name ? ` AND BKMO:1&search=NAME:${form.name}` : "";
      const bhcRSSD = form.bhcRSSD ? ` AND RSSDHCR:${form.bhcRSSD}` : "";
      const year = form.lastYear ? ` YEAR:${form.lastYear}` : "";

      setPrevAppState(form);
      (async () => {
        fetchData(
          `${ApiBaseUrl()}/sod?filters=${year}${cert}${bhcRSSD}${name}&agg_by=STALPBR&agg_sum_fields=DEPSUMBR&sort_by=STNAMEBR&sort_order=ASC`,
        )
          .then(response => {
            if (isMounted) {
              const arrayOfStates = response.data.map((val: KeyValue) => {
                return {
                  label: selectedStatesAlpha.find(
                    state => state.value === val.STALPBR,
                  )?.label,
                  value: val.STALPBR,
                };
              });
              setStateList(arrayOfStates);
            }
          })
          .catch((error: Error) => console.error(error))
          .finally(() => (isMounted = false));
        //if we pass in the state to determine when the call has been completed, we pass that state once it is done.
      })();
    }
  }, [form, prevAppState, stateList]);

  useEffect(() => {
    if (stateList.length && form.stalpbr && form.stalpbr !== "ALL") {
      const arrayOfKeys = stateList.map((list: KeyValue) => list.value);
      if (!arrayOfKeys.includes(form.stalpbr)) {
        setForm({ ...form, stalpbr: "ALL" });
      }
    }
  }, [form, setForm, stateList]);

  return stateList;
}
